import React, { Component } from "react";
import { Header } from "semantic-ui-react";
import { ItemsSearch } from "./ItemsSearch";
import { CheckedInItems } from "./CheckedInItems";
import { loanApi } from "@api/loans";
import { withCancel } from "@api/utils";
import { invenioConfig } from "@config";

export default class CheckIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedInItems: [],
      loans: null,
      isLoading: false,
      error: null,
    };
  }

  // Function to check if item/loan is overdue using the same pattern as OverdueLoansList
  checkOverdue = async (barcode) => {
    try {
      // Build query to find overdue loans with this specific barcode
      const overdueQuery = loanApi
        .query()
        .overdue()
        .withState(invenioConfig.CIRCULATION.loanActiveStates)
        .withItemBarcode(barcode) // Filter by specific barcode
        .qs();

      // Use withCancel like in OverdueLoansList
      const cancellableFetch = withCancel(loanApi.list(overdueQuery));

      const response = await cancellableFetch.promise;

      // Check if any overdue loans found for this barcode
      if (response.data.hits && response.data.hits.length > 0) {
        const overdueLoan = response.data.hits[0];
        return {
          isOverdue: true,
          loanId: overdueLoan.metadata.pid,
          patronId: overdueLoan.metadata.patron.pid,
          patronName: overdueLoan.metadata.patron.name,
          endDate: overdueLoan.metadata.end_date,
          documentTitle: overdueLoan.metadata.document.title,
        };
      }

      return { isOverdue: false };
    } catch (error) {
      return { isOverdue: false };
    }
  };

  // Function to search for loans by barcode using existing API pattern
  searchForCheckIn = async (barcode) => {
    try {
      this.setState({ isLoading: true, error: null });

      // Search for active loans with this barcode
      const loanQuery = loanApi
        .query()
        .withState(invenioConfig.CIRCULATION.loanActiveStates)
        .withItemBarcode(barcode)
        .qs();

      const cancellableFetch = withCancel(loanApi.list(loanQuery));
      const response = await cancellableFetch.promise;

      this.setState({
        loans: response.data,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        error: error.message,
        isLoading: false,
      });
    }
  };

  // Function to perform the actual check-in
  checkin = async (barcode, callback) => {
    try {
      this.setState({ isLoading: true, error: null });

      // Check if the checkin API method exists and use appropriate method
      let response;
      if (loanApi.checkin) {
        response = await loanApi.checkin(barcode);
      } else if (loanApi.checkIn) {
        response = await loanApi.checkIn(barcode);
      } else if (loanApi.returnItem) {
        response = await loanApi.returnItem(barcode);
      } else {
        throw new Error("No check-in API method available");
      }

      // Add the checked-in item to the list
      this.setState((prevState) => ({
        checkedInItems: [
          response.item || response,
          ...prevState.checkedInItems,
        ],
        loans: null,
        isLoading: false,
      }));

      // Call the callback to clear the search input
      if (callback) {
        callback();
      }
    } catch (error) {
      this.setState({
        error: error.message,
        isLoading: false,
      });
    }
  };

  // Function to clear results (for CheckedInItems component)
  clearResults = () => {
    this.setState({
      checkedInItems: [],
      loans: null,
      error: null,
    });
  };

  render() {
    const { checkedInItems, loans, isLoading, error } = this.state;

    return (
      <>
        <Header as="h2">Check-in physical copies</Header>

        {error && (
          <div style={{ color: "red", marginBottom: "1rem" }}>
            Error: {error}
          </div>
        )}

        <ItemsSearch
          checkin={this.checkin}
          checkOverdue={this.checkOverdue}
          searchForCheckIn={this.searchForCheckIn}
          loans={loans}
          isLoading={isLoading}
        />

        <CheckedInItems
          items={checkedInItems}
          clearResults={this.clearResults}
        />
      </>
    );
  }
}
